import React from 'react';

const words = ['Honest moments', 'Artful light', 'Timeless stories', 'Editorial spirit', 'Quiet luxury'];

function Marquee() {
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div className="marquee-half" key={half}>
            {words.map((word) => (
              <span key={word}>{word} <i>✳</i></span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
